import { useEffect, useState } from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import map from "highcharts/modules/map";
import brazil from "@highcharts/map-collection/countries/br/br-all.geo.json";

import { api } from '../../services/api';
import axios from 'axios';

type mapDataType = {
  value: Number | null | undefined;
  index: Number;
  name: String;
}

type BrazilMapProps = {
  onSelectMap: any;
  title: string;
  seriesName: string;
}

map(Highcharts)
export default function BrazilMap(props: BrazilMapProps) {
  const [dataMapArr, setDataMapArr] = useState([]);

  function handleClickMap(propsHandle: mapDataType) {
    props.onSelectMap(propsHandle);
  }

  useEffect(() => {
    type arrProps = [[string, number]];
    const reqSP = api.get("estado/SP/overview")
    const reqMG = api.get("estado/MG/overview")
    axios.all([reqSP, reqMG])
      .then(axios.spread((...responses) => {
        const reqSP = responses[0];
        const reqMG = responses[1];
        // const reqMA = responses[1];
        // const reqPA = responses[2];
        // const reqSC = responses[3];
        // const reqBA = responses[4];
        // const reqAP = responses[5];
        // const reqMS = responses[6];
        // const reqMG = responses[7];
        // const reqGO = responses[8];
        // const reqRS = responses[9];
        // const reqTO = responses[10];
        // const reqPI = responses[11];
        // const reqAL = responses[12];
        // const reqPB = responses[13];
        // const reqCE = responses[14];
        // const reqSE = responses[15];
        // const reqRR = responses[16];
        // const reqPE = responses[17];
        // const reqES = responses[18];
        // const reqRJ = responses[19];
        // const reqRN = responses[20];
        // const reqAM = responses[21];
        // const reqMT = responses[22];
        // const reqDF = responses[23];
        // const reqAC = responses[24];
        // const reqRO = responses[25];
        const arr: arrProps = [['br-sp', reqSP.data.total_dose1]];
        arr.push(['br-mg', reqMG.data.total_dose1]);
        //@ts-ignore
        setDataMapArr(arr);
        handleClickMap({
          value: 0,
          index: 0,
          name: "São Paulo",
        })
      }))
  }, []);

  //configurações da página de BrazilMap
  const chartOptions: Highcharts.Options = {
    title: {
      text: props.title
    },
    chart: {
      map: brazil
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom'
      }
    },
    colorAxis: {
      min: 0
    },
    series: [
      {
        name: props.seriesName,
        type: 'map',
        //necessario ts ignore devido a bug do typescript
        // @ts-ignore
        data: dataMapArr,
        states: {
          hover: {
            color: '#BADA55'
          }
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        },
        point: {
          events: {
            click: function () {
              //this.name => recebe os dados do nome
              //possibilidade do uso de index para capturar o filtro por SP
              const dataOutput: mapDataType = {
                value: this.value,
                index: this.index,
                name: this.name,
              }
              handleClickMap(dataOutput)
            }
          }
        }
      }
    ]
  };

  return (<>
    <HighchartsReact //Brazil Map
      constructorType="mapChart"
      highcharts={Highcharts}
      options={chartOptions}
    />
  </>)
}